import React from 'react';
import { Card, CardContent, CardActions, Typography, IconButton } from '@mui/material';
import { Download, Edit, Delete } from '@mui/icons-material';

const PlaylistCard = ({ playlist, role, onEdit, onDelete, onDownload }) => {
  return (
    <Card 
      variant="outlined" 
      sx={{ 
        backgroundColor: "#4b445b",
        width: '100%',
        height: '400px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CardContent>
        <Typography
          gutterBottom
          variant="h5"
          component="div"
          color="secondary"
        >
          {new Date(playlist.startTime).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })}{" "}
          -{" "}
          {new Date(playlist.endTime).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </Typography>
        <Typography
          variant="body2"
          color="secondary"
          sx={{
            display: "-webkit-box",
            WebkitLineClamp: 10,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            height: "200px",
            whiteSpace: "pre-line",
          }}
        >
          {playlist.playlist.map((x) => x.item).join("\n")}
        </Typography>
      </CardContent>
      <CardActions sx={{ marginTop: 'auto' }}>
        {["admin"].includes(role) && (
          <IconButton
            aria-label="download"
            onClick={onDownload}
            color="secondary"
            sx={{ marginLeft: "auto" }}
          >
            <Download />
          </IconButton>
        )}
        <IconButton
          aria-label="edit"
          onClick={onEdit}
          color="secondary"
        >
          <Edit />
        </IconButton>
        <IconButton
          aria-label="delete"
          onClick={onDelete}
          color="secondary"
        >
          <Delete />
        </IconButton>
      </CardActions>
    </Card>
  );
};

export default PlaylistCard; 